import $ from 'jquery';
import voiture from '../../../resources/front/images/illustrations/voiture.jpg';

export default class VehicleConditionManager {
    /**
     * Downloads the vehicle condition.
     *
     * @param {int} vehicleId The vehicle identifier
     * @param {function} onSuccess The function to execute on success
     * @param {function} onFail The function to execute on fail
     * @return {void}
     */
    static getVehicleCondition(vehicleId, onSuccess, onFail) {
        $.ajax({
            url: `/get-car-condition/${vehicleId}`,
            dataType: 'json',
            method: 'GET',
        })
            .done(response => onSuccess(response))
            .fail(onFail);
    }

    /**
     * Downloads the pictures of a list of defaults.
     *
     * @param {{}[]} defaults The list of defaults
     * @param {function} onPictureChange
     * @return {void}
     */
    static downloadPictures(defaults, onPictureChange) {
        defaults.forEach(def => this.downloadPicturesOfDefault(def, onPictureChange));
    }

    /**
     * Downloads the pictures of a default.
     *
     * @param {{}} def The default
     * @param {function} onPictureChange
     * @return {void}
     */
    static downloadPicturesOfDefault(def, onPictureChange) {
        def.pictures.forEach(picture => this.downloadPicture(def, picture, onPictureChange));
    }

    /**
     * Downloads a picture of a default.
     *
     * @param {{}} def The default
     * @param {{
     *     downloaded: boolean|undefined,
     *     downloading: boolean|undefined,
     *     error: boolean|undefined,
     *     height: int,
     *     img: HTMLImageElement|undefined,
     *     shapes: {}[],
     *     width: int,
     * }} picture The picture to download
     * @param {function} onPictureChange Function called when a picture is downloaded
     * @return {void}
     */
    static downloadPicture(def, picture, onPictureChange) {
        const {
            downloading,
            downloaded,
            id,
            mimeType,
        } = picture;

        if ((!downloaded) && (!downloading)) {
            onPictureChange({
                ...picture,
                downloading: true,
            });

            $
                .ajax({
                    url: `/vehicle-condition/default-picture/${id}?mimeType=${mimeType}`,
                })
                .done(response => {
                    const img = new Image();
                    img.onload = () => onPictureChange({
                        ...picture,
                        downloaded: true,
                        downloading: false,
                        img,
                    });
                    img.src = response;
                })
                .fail(({ status }) => {
                    if (status === 404) {
                        const imgNotFound = new Image();
                        imgNotFound.onload = () => onPictureChange({
                            ...picture,
                            downloaded: true,
                            downloading: false,
                            img: imgNotFound,
                            height: imgNotFound.height,
                            shapes: [],
                            width: imgNotFound.width,
                        });
                        imgNotFound.src = voiture;
                    } else {
                        onPictureChange({
                            ...picture,
                            downloaded: true,
                            downloading: false,
                            error: true,
                        });
                    }
                });
        }
    }

    /**
     * Returns the scale and the dimensions to display the picture in the available space.
     *
     * @param {{}} picture The picture
     * @param {int} availableWidth The available width
     * @param {int} availableHeight The available height
     * @return {{
     *     imgScaleHeight: number,
     *     imgScaleWidth: number,
     *     scale: number,
     * }}
     */
    static getScaleAndDimensionsToDisplayPicture(picture, availableWidth, availableHeight) {
        const { width: pictureWidth, height: pictureHeight } = picture;
        const scaleWidth = (pictureWidth > availableWidth) ? (availableWidth / pictureWidth) : 1.0;
        const scaleHeight = (pictureHeight > availableHeight) ? (availableHeight / pictureHeight) : 1.0;
        const scale = Math.min(scaleWidth, scaleHeight);

        return {
            scale,
            imgScaleWidth: scale * pictureWidth,
            imgScaleHeight: scale * pictureHeight,
        };
    }
}
